import { render, staticRenderFns } from "./LotFurnitureItem.vue?vue&type=template&id=b2767018&"
import script from "./LotFurnitureItem.vue?vue&type=script&lang=js&"
export * from "./LotFurnitureItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports